import decorativo from '../../../Assets/img/shape13.svg'
import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos'
import PropuestaValor from '../Components/PropuestaValor'
import Asesoramiento from '../Components/Asesoramiento'
import Formulario from '../Components/Formulario';
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from '../Components/Navbar'
import { useConfig } from '../../../context/ConfigContext'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

export const FlotaVehiculos = () => {

    const {origen:parametros, config} = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle: "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar rubro='auto' />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro para Flota de Vehículos'
                    url='#formulario'
                    icon='#icon-seg-flota'
                    subTitulo={{ __html: "Asegurá la flota de vehículos de tu empresa con un plan diseñado para cubrir todas tus necesidades.<br/><br/>¿Empezamos?" }}
                    color={parametros!.origen !== "SEGURARSE" ? parametros!.bgColor : undefined}
                />
                <div className={`pt-70 pt-lg-80 pb-40 position-relative ${parametros!.origen === "SEGURARSE" && "bg-primary"}`}
                    style={parametros!.origen !== "SEGURARSE" ? { backgroundColor: parametros!.bgColor } : {}}>
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Te acercamos y asesoramos sobre una gran variedad de coberturas para los vehículos de tu empresa, asegurando una solución integral y efectiva brindando protección financiera en caso de daños o lesiones.
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Dentro de las principales coberturas, se incluyen:
                            </p>
                        </div>

                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Responsabilidad civil:</b> cubre los daños causados a terceros, incluyendo lesiones personales y daños a la propiedad, en caso de accidentes de vehículos de la flota. Esto puede incluir gastos médicos, costos de reparación de vehículos dañados y posibles reclamaciones legales.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Cobertura ante colisión:</b> cubre los daños a los vehículos de la flota en caso de choques con otros vehículos u objetos. Esta cobertura puede incluir los costos de reparación o reemplazo de los vehículos dañados.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Cobertura integral:</b> cubre los daños a los vehículos de la flota que no sean resultado de una colisión, como incendios, robos, vandalismo o desastres naturales.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Protección contra lesiones personales:</b> cubre los gastos médicos e indemnizaciones por lesiones sufridas de los conductores o pasajeros de los vehículos de la flota en caso de accidentes.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Asistencia mecánica:</b> proporciona servicios de asistencia en carretera, como remolque de vehículos, asistencia en caso de avería, servicios de cerrajería, suministro de combustible, entre otros.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formulario
                    rubro='Vehículos'
                    titulo='Cotizá seguro para Flota de Vehiculos'
                    origen={parametros!.origen}
                    extras={parametros!.riesgoData.find(riesgo => riesgo.id === "flotas_vehiculos")?.formulario}
                />
                <PorQueElegirnos color={parametros!.bgColor} />
                <PropuestaValor
                    origen={parametros!.origen}
                    color={parametros!.bgColor}
                />
                {/* {parametros!.origen === "SEGURARSE" &&
                    <Asesoramiento />
                } */}
            </div>
        </>
    )
}
